import React, { useState } from 'react';

import ChartCombo, { ChartComboItem } from '../chartCombo/chartCombo';

// styles
import './datasetComboHealth.scss';

interface Props {
  options: ChartComboItem[];
  value: ChartComboItem;
  onChange: (value: ChartComboItem) => void;
}

const DatasetCombo = (props: Props) => {
  return (
    <div className="datasetCombo">
      <ChartCombo label="Einkommensgruppe" mode="combo" onChange={props.onChange} options={props.options} selectedItem={props.value}></ChartCombo>
    </div>
  );
};

export default DatasetCombo;
